// --- EMERGENCY SESSION FIX - Must be at the very top ---
window.$session = {
	get(key) {
		const sessionValue = sessionStorage.getItem(key);
		if (sessionValue === null) return null;
		try {
			return JSON.parse(sessionValue);
		} catch (e) {
			return sessionValue;
		}
	},
	set(key, value) {
		try {
			sessionStorage.setItem(key, JSON.stringify(value));
		} catch (e) {
			sessionStorage.setItem(key, value);
		}
	},
	remove(key) {
		sessionStorage.removeItem(key);
	},
	clear() {
		sessionStorage.clear();
	},
	has(key) {
		return sessionStorage.getItem(key) !== null;
	},
	exists(key) {
		return this.has(key);
	},

	// UPPERCASE methods
	GET(key) {
		return this.get(key);
	},
	SET(key, value) {
		return this.set(key, value);
	},
	REMOVE(key) {
		return this.remove(key);
	},
	CLEAR() {
		return this.clear();
	},
	HAS(key) {
		return this.has(key);
	},
	EXISTS(key) {
		return this.exists(key);
	},
};

// Make it globally available
global.$session = window.$session;

// --- Vue imports ---
import Vue from 'vue';
import App from './App';
import store from './vuex';
import router from './router/routes';
import Packages from './packages';
import '@nana-tec/ui';
import './assets/tailwind.css';
import './index.css';

// --- Service Worker registration (Vue CLI PWA plugin) ---
// Only keep ONE registration method, not both
// import './registerServiceWorker'

// Attach $session plugin
Vue.prototype.$session = window.$session;

Vue.config.productionTip = process.env.NODE_ENV === 'production';
Vue.config.ignoredElements = ['product-benefit'];

// Initialize app
new Packages(new Vue());
new Vue({
	el: '#app',
	router,
	store,
	render: (h) => h(App),
	created() {
		if (this.$store.dispatch) {
			this.$store.dispatch('loadSessionData');
		}
	},
});
if ('serviceWorker' in navigator) {
	navigator.serviceWorker
		.register('/serviceWorker.js')
		.then((registration) => {
			console.log('Service Worker registered:', registration);

			// Listen for updates
			registration.onupdatefound = () => {
				const installingWorker = registration.installing;
				installingWorker.addEventListener('statechange', () => {
					if (
						installingWorker.state === 'installed' &&
						navigator.serviceWorker.controller
					) {
						console.log('New update available!');
						if (
							confirm('A new update is available. Refresh now?')
						) {
							window.location.reload(); // Reload to apply updates
						}
					}
				});
			};
		});
}
// //
